<template>
  <v-container>
     <!-- Used to display company education responsible -->
    <CompanyEmployeeList
      type="companyEducationResponsible"
      :title="$t('roles.CompanyEducationResponsible')"
      :isDepartments="hasDepartments($route.params.id)"
      :MessageBoxText="$t('company.department-yua-info') + ' ' + getCurrentUserDepartments($route.params.id, isAdministrator, isDepartmentAdministrator($route.params.id))"      
    />
  </v-container>
</template>

<script>
import CompanyEmployeeList from "@/components/Company/CompanyEmployeeList"
import { CompanyRoles } from '@/components/mixins'
import {mapGetters, mapActions} from 'vuex'

// @group Company
// CompanyYUA component
export default {
  name: "CompanyYUA",

  mixins: [CompanyRoles],

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isAdministrator', "isDepartmentAdministrator"]),
  },

  components: {
    CompanyEmployeeList,
  },
};
</script>

<style lang="scss">
</style>